import { render } from "./CxTabControl.vue?vue&type=template&id=c0a1af4c"
import script from "./CxTabControl.vue?vue&type=script&lang=js"
export * from "./CxTabControl.vue?vue&type=script&lang=js"

import "./CxTabControl.vue?vue&type=style&index=0&id=c0a1af4c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__